"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _components = _interopRequireDefault(require("../../styles/components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var ListSection = /*#__PURE__*/function (_React$PureComponent) {
  _inheritsLoose(ListSection, _React$PureComponent);

  function ListSection() {
    return _React$PureComponent.apply(this, arguments) || this;
  }

  var _proto = ListSection.prototype;

  _proto.render = function render() {
    var _this$props = this.props,
        title = _this$props.title,
        children = _this$props.children,
        icon = _this$props.icon;
    var sectionId = "section";
    if (this.props.id) sectionId = this.props.id;
    return /*#__PURE__*/_react["default"].createElement("div", {
      style: {
        padding: "20px"
      }
    }, icon ? /*#__PURE__*/_react["default"].createElement(_components["default"].ListSectionIcon, null, icon, /*#__PURE__*/_react["default"].createElement(_components["default"].ListSectionTitle, {
      style: {
        marginLeft: '5px'
      }
    }, title)) : /*#__PURE__*/_react["default"].createElement(_components["default"].ListSectionTitle, null, title), /*#__PURE__*/_react["default"].createElement(_components["default"].ListSectionContent, {
      id: sectionId
    }, children.length ? children : /*#__PURE__*/_react["default"].createElement(_components["default"].ListSectionNoData, null, children.length ? children : "No data")));
  };

  return ListSection;
}(_react["default"].PureComponent);

var _default = ListSection;
exports["default"] = _default;